module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Each of the audio, video, or still image media examples listed below is associated with specific passages in this book, and each example has been assigned a unique persistent uniform resource identifier, or PURL. The PURL points to the location of a specific audio, video, or still image media example on the Ethnomusicology Multimedia website, "), _c('a', {
    attrs: {
      "href": "http://www.ethnomultimedia.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ethnomultimedia.org")]), _vm._v(". Within the running text of the book, a “PURL number” in parentheses functions like a citation and immediately follows the text to which it refers, for example, (PURL 3.1). The numbers following the word “PURL” relate to the chapter in which the media example is found and the number of PURLs contained in that chapter. For example, PURL 3.1 refers to the first media example found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(", PURL 3.2 refers to the second media example found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(", and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("There are two ways to access and play back a specific audio, video, or still image media example. When readers enter into a web browser the full address of the PURL associated with a specific media example, they will be taken to a web page containing that media example as well as a playlist of all of the media examples related to this book. Information about the book and the author is also available through this web page. Once readers have navigated to the Ethnomusicology Multimedia website they may also access media examples by entering into the “Media Segment ID” search field the unique six-digit PURL identifier located at the end of the full PURL address. Readers will be required to electronically sign an end-user license agreement the first time they attempt to access a media example on the Ethnomusicology Multimedia project website.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("CHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 1.1 | Women of Goibei PAG church, “Vali no vugasu” (Blessed are they)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/idl/em/Kidula/910190",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/idl/em/Kidula/910190")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 2.1 | Jean Kidula, “Si walinda ndeya” (You did not wait for me to clean up the house)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910183",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910183")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 2.2 | Jean Kidula, “Lelo kunyoye idimbidi” (We have now acquired one who is deaf and dumb)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910184",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910184")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 2.3 | Jean Kidula, “Long’oli.”")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910186",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910186")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 2.4 | Jean Kidula, “Tula ichova” (Come on out)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910187",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910187")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 2.5 | Jean Kidula, “Lufweye kulanga baba” (Calling him dad is over).")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910204",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910204")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 2.6 | Jean Kidula, “Mwilwadze kuli Petero Yilwadza” (Preach as Peter did)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910179",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910179")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 3.1 | Women of Goibei PAG church, “Kwenya kulola vamuyanza” (We want to see those who love the [person])")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910188",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910188")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 3.2 | Jean Kidula, “Sisi was Goibei” (We, of Goibei)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910170",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910170")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 3.3 | Jean Kidula, “Kwinye vaana va Goibei”(We, the children of Goibei)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910185",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910185")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 3.4 | Jean Kidula, “Elori” (A lorry)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910169",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910169")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 3.5 | Focus group of Goibei Women, Set beginning with “Mulikhayira yambonyia” (He lifted me up)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910181",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910181")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("CHAPTER 4")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 4.1 | Focus group of Goibei Women, “Ni ngusaalilanga” (While I am praying for you)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910174",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910174")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 4.2 | Jean Kidula, “A tonde.”")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910168",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910168")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 5.1 | Women of Goibei PAG church, “Kale mmadiku yago” (In those long ago days)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910167",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910167")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.2 | Focus group of Goibei Women, “Yesu oveye lwanda” (Jesus you are a rock)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910166",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910166")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.3 | Focus group of Goibei Women, “Njereranga” (I am returning [home])")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910202",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910202")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.4 | Focus group of Goibei Women, “Lwa inze ndola” (When I see/survey)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910165",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910165")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.5 | Women of Goibei PAG church, “O Yesu nguyanza” (Oh Jesus, I love you)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910164",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910164")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.6 | Visukulu va Zakayo, “Si gali masahi” (It was not the blood of beasts) and “O Yesu nguyanza”(Oh Jesus I love you)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910163",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910163")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.7 | Focus group of Goibei Women, “Lwa avayi vali ni valinda” (While shepherds watched)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910173",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910173")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.8 | Jean Kidula, “Mu mugera gwe liluva” (In the fishing river)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910172",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910172")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.9 | Women of Goibei PAG Church, “Mukonyi ali himbi” (The great physician)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910203",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910203")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.10 | Focus group of Goibei Women, “Ya kudzera” (He died [The solid rock])")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910201",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910201")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.11 | Avisukulu va Zakayo Imbukule, “Kwake Yesu” (On Jesus [The solid rock])")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910200",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910200")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 5.12 | Quaker women’s group, “Ndilonda ku inzila” (I will take the road)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910182",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910182")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 6.1 | Focus group of Goibei Women, “Ligulu lili ihale” (The heavens are yonder)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910199",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910199")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 6.2 | Jean Kidula, “Ingata yange ufwale” (Vest me with my crown)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910198",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910198")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 6.3 | Focus group of Goibei Women, “Kidaho kyo mwigulu” (The river of heaven)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910197",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910197")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 6.4 | Focus group of Goibei Women, Song set beginning with “Yesu yasaala” (Jesus prayed)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910176",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910176")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 7.1 | Kariokor Friends Choir, “Gendi kwilwadze” (Let us preach)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910196",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910196")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 7.2 | Kariokor Friends Choir, “Valimu vayuda” (Traitors are in [our] midst)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910171",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910171")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 7.3 | Kariokor Friends Choir, “Lisuvira, Kwinye kogende” (Faith, let us walk)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910195",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910195")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 7.4 | Focus group of Goibei women, “Musalaba” (The cross)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910194",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910194")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("PURL 7.5 | Kenyatta University Choir, “Musalaba.” (Kemoli Arrangement) (The cross)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910193",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910193")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 7.6 | Francis and Keren Illavadza, “Ulivolela.” (1992 version) (What will you say)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910192",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910192")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 7.7 | Francis and Keren Illavadza, “Ulivolela.” (2008 version) (What will you say)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910191",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910191")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("PURL 8.1 | Focus group of Goibei Women, Women introduce themselves and sing set beginning with “Valoji valalila” (Sorcerers will cry)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910175",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910175")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PURL 8.2 | Focus group of Goibei Women, Set featuring “Heri Kuwa na Yesu”")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    staticClass: "un",
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Kidula/910180",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Kidula/910180")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b68aca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 75
// module chunks = 0